import { NavLink } from "react-router-dom";

export const LienNav = (props) => {
    return(
        <NavLink exact to={props.path} activeClassName={'bg-cyan-800 text-white'} className={"w-full text-cyan-100 group flex items-center px-2 py-2 text-sm leading-6 font-medium rounded-md"}  aria-current="page">
            {props.icon}
            {props.name}
        </NavLink>
    );
}